import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { LoginService } from '../../../service/Login/login.service';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { AssetsService } from '../../../service/Assets/assets.service';
import { Login, LoginInput } from '../../../class/Login/login';
import { AppComponent } from '../../../app.component';
import { RegisterService } from '../../../service/Register/register.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  // @ViewChild('otp1') otp1!: ElementRef;
  @ViewChild('otp2') otp2!: ElementRef;
  @ViewChild('otp3') otp3!: ElementRef;
  @ViewChild('otp4') otp4!: ElementRef;

  constructor(

    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private toaster: ToastrService,
    private assetsService: AssetsService,
    private appcomponent: AppComponent,
    private fb: FormBuilder,
    private registerService: RegisterService,
  ) { }

  formGroup!: FormGroup;
  Loader: boolean = false;
  hidePassword = true;
  login_tab = true;
  otp_tab = false;
  OtpSend: boolean = false;
  OtpVerify: boolean = false;
  mobile_number: any;
  set_mask: any;

  resendVerify: boolean = false;
  resendVerificationForm!: FormGroup;
  isSubmitted: boolean = false;
  emailExists: boolean = false;
  emailExistsError: string = '';

  form = {
    emailOrMobileNumber: '',
    password: '',
    // pec_ipaddress: [localStorage.getItem('getip') !== null ? localStorage.getItem('getip') : '0.0.0.0'],
    // pec_browser: [localStorage.getItem('getbrowser') !== null ? localStorage.getItem('getbrowser') : '-'],
    // pec_browser_ver: [localStorage.getItem('getbrowser_version') !== null ? localStorage.getItem('getbrowser_version') : '-'],
    // pec_os: [localStorage.getItem('getostype') !== null ? localStorage.getItem('getostype') : '-'],
  };

  otp = {
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: ''
  };

  ngOnInit() {
  }

  moveFocus(event: any, nextInput?: HTMLInputElement) {
    if (event.target.value.length === event.target.maxLength && nextInput) {
      nextInput.focus();
    }
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  // checkEmailFormat(): boolean {
  //   const Email_Regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   if (!Email_Regex.test(this.form.email.trim())) {
  //     this.toaster.error('Invalid Email Format');
  //     return false;
  //   }
  //   return true;
  // }

  checkEmailOrMobileNumberFormat(): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobileRegex = /^[0-9]{10}$/; // Assuming a 10-digit mobile number

    if (!emailRegex.test(this.form.emailOrMobileNumber) && !mobileRegex.test(this.form.emailOrMobileNumber)) {
      this.toaster.error('Invalid Email or Mobile Number Format');
      return false;
    }
    return true;
  }


  LoginonSubmit(form: any): void {

    if (form.valid) {

      if (!this.checkEmailOrMobileNumberFormat()) {
        return;
      }

      this.Loader = true;

      let formData = new FormData();
            // formData.append('email',this.form.email);
            formData.append('emailOrMobileNumber', this.form.emailOrMobileNumber);
            formData.append('password', this.form.password);
            formData.append('verifiy', 'true');
            this.Loader = true;

            this.loginService.GoLogin(formData).subscribe({
              next: (res: LoginInput) => {

                this.login_tab = true;
                this.otp_tab = false;

                this.Loader = false;
                if (res.status == "success") {

                  this.login_tab = false;
                  this.otp_tab = true;
                  // let get_error = res.error.message.status ? err.error.message.status.join(', ') : 'Unknown error occurred';
                  
                  if (res.user_type === 6) {
                    this.Loader = true;
                    localStorage.setItem('token', res.token);
                    this.toaster.success("Logged-In Successfully");
                    this.router.navigate(["/register-bulk-upload"]);
                  }else {
                    this.login_tab = true;
                    this.toaster.error('Unknown User Type');
                  }

                  setTimeout(() => {
                    this.appcomponent.ngOnInit();
                    // this.router.navigate(["/"]);
                  }, 1000);

                } else {
                  this.toaster.error('error');
                }

              }, error: (err) => {
                this.Loader = false;
                // console.log(err.status);
                if (err.error && err.error.message) {
                  let get_error = err.error.message.status ? err.error.message.status.join(', ') : 'Unknown error occurred';
                  this.toaster.error(get_error);
                } else {
                  this.toaster.error('An unknown error occurred.');
                }

              }
            });

    }
    else {
      console.log('Form is invalid');
      form.form.markAllAsTouched();
    }
  }


  emailExistsCheck() {
    return new Promise((resolve, reject) => {
      const email = this.resendVerificationForm.get('resendEmail')?.value;

      this.registerService.EmailCheckExists(email).subscribe(
        (response: any) => {  
          this.emailExists = false;
          resolve(true); 
        },
        (error: any) => {
          this.emailExists = true;
          this.emailExistsError = error.error.message.email;
          resolve(false); 
        }
      );
    });
  }

}
